import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fieldsProductContact(id) {
  const url = `/contacts/clients/${id}/accounts-fields/`;
  const response = await httpManager.get(url);
  return response.data;
}
